import React, { useEffect, useState } from 'react'
import './Auth.css'
import Logo from '../../img/appiconcrop3.png'
import { useDispatch, useSelector } from 'react-redux'
import { clearAuthError, logIn, signUp, forgotPass } from '../../actions/AuthAction'
import { Link, useNavigate } from 'react-router-dom'
import usePageTracking from '../../hooks/usePageTracking'

const Auth = () => {
    usePageTracking('ns_auth');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {loading, error, message} = useSelector((state)=>state.authReducer);
    const [rightComponent, setRightComponent] = useState("logIn");
    const [showPassword0, setShowPassword0] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);

    const togglePasswordVisibility0 = () => {
        setShowPassword0(!showPassword0);
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const togglePasswordVisibility2 = () => {
        setShowPassword2(!showPassword2);
    };

    const blankDataObj = {
        email: "",
        displayname: "", 
        username: "", 
        password: "", 
        confirmPassword: "", 
        userType: "0",
        signupKey: ""
    }

    useEffect(()=>{
        
        switch (rightComponent) {
            case "signUp":
                if (error !== null) {
                    const signupValEl = document.getElementById("auth_signup_validation");
                    signupValEl.classList.remove("General-hidden")
                    switch (error) {
                        case 400:
                            signupValEl.innerText = message;
                            break;
                        case 403:
                            signupValEl.innerText = message;
                            break;
                        case 500:
                            signupValEl.innerText = "A server error has occurred.  Please try again later.";
                            break;
                        default:
                            signupValEl.innerText = "An error has occurred.  If the problem persists, please try again later.";
                    }
                } else {
                    // hide signupvalel?
                }
                break;
            case "logIn":
                if (error !== null) {
                    const loginValEl = document.getElementById("auth_login_validation")
                    loginValEl.classList.remove("General-hidden")
                    switch (error) {
                        case 400:
                        case 404:
                            loginValEl.innerText = "Incorrect username or password.";
                            break;
                        case 500:
                            loginValEl.innerText = "A server error has occurred.  Please try again later.";
                            break;
                        default:
                            loginValEl.innerText = "";
                    }
                }
                break;
            case "forgot":
                const forgotValEl = document.getElementById("auth_forgot_validation")
                if (error !== null) {
                    forgotValEl.classList.remove("General-hidden")
                    forgotValEl.classList.remove("General-validationSuccess");
                    forgotValEl.classList.add("General-validationError");
                    switch (error) {
                        case 400:
                            forgotValEl.innerText = "Bad request.";
                            break;
                        case 404:
                            forgotValEl.innerText = "This user does not exist.";
                            break;
                        case 500:
                            forgotValEl.innerText = "A server error has occurred.  Please try again later.";
                            break;
                        default:
                            forgotValEl.innerText = "";
                    }
                }
                if (message !== null) {
                    forgotValEl.classList.remove("General-hidden", "General-validationError");
                    forgotValEl.classList.add("General-validationSuccess");
                    console.log("Inside message");
                    console.log(message);
                    forgotValEl.innerText = message;
                }
                break;
        }
        if (error !== null || message !== null) {
            const timer = setTimeout(() => {
                dispatch(clearAuthError());
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [error, message, rightComponent])

    const [data, setData] = useState(blankDataObj);

    const handleChange = (e)=> {
        setData({...data, [e.target.name]: e.target.value});
    }

    const handleSubmitSignup = async (e) => {
        e.preventDefault();
        const signupValEl = document.getElementById("auth_signup_validation");
        if (data.password !== data.confirmPassword) {
            signupValEl.innerText = "Your passwords do not match.";
            signupValEl.classList.remove("General-hidden");
        } else if (
            document.getElementById("auth_displayname").value === '' || 
            document.getElementById("auth_username").value === '' ||
            document.getElementById("auth_password").value === '' ||
            document.getElementById("auth_confirm").value === '') {
            signupValEl.innerText = "Please fill in all fields.";
            signupValEl.classList.remove("General-hidden");
        } else if (document.getElementById("auth_password").value.length < 8) {
            signupValEl.innerText = "Your password must be at least 8 characters long.";
            signupValEl.classList.remove("General-hidden");
        } else {
            signupValEl.classList.add("General-hidden");
            dispatch(signUp(data)) 
        }
    }

    const handleSubmitLogin = async (e) => {
        e.preventDefault();
        const loginValEl = document.getElementById("auth_login_validation")
        if  (document.getElementById("login_username").value === '' ||
            document.getElementById("login_password").value === '') {
                console.log("Login not all fields")
            loginValEl.innerText = "Please fill in all fields.";
            loginValEl.classList.remove("General-hidden");
        } else {
            loginValEl.classList.add("General-hidden");
            dispatch(logIn(data))
        }
    }

    const handleSubmitForgot = async (e) => {
        e.preventDefault();
            dispatch(forgotPass(data));
    }

    const renderRightComponent = () => {
        switch (rightComponent) {
            case "signUp":
                return <SignUp
                setRightComponent={setRightComponent}
                handleChange = {handleChange}
                handleSubmitSignup = {handleSubmitSignup}
                loading = {loading}
                showPassword={showPassword} 
                showPassword2={showPassword2}
                togglePasswordVisibility={togglePasswordVisibility}
                togglePasswordVisibility2={togglePasswordVisibility2}
                data={data}
                />
            case "logIn":
                return <LogIn
                setRightComponent={setRightComponent}
                handleChange = {handleChange}
                loading = {loading}
                handleSubmitLogin = {handleSubmitLogin}
                showPassword0={showPassword0}
                togglePasswordVisibility0={togglePasswordVisibility0}
                />
            case "forgot":
                return <Forgot
                setRightComponent={setRightComponent}
                handleChange = {handleChange}
                loading = {loading}
                handleSubmitForgot = {handleSubmitForgot}
                />
        }
    }

  return (
    <div className="Auth">
        <div className="auth-left">
            <Link style={{textDecoration: "none", color: "inherit"}} to={'/landing'}><img src={Logo} alt="" className='auth-logo' /></Link>
        </div>
        {renderRightComponent()}
    </div>
  )
}

function LogIn({ setRightComponent, handleChange, loading, handleSubmitLogin, showPassword0, togglePasswordVisibility0 }) {
    return (
        <div className="auth-right">
            <form action="" className="input-form" onSubmit={handleSubmitLogin}>
                <h3>Log In</h3>
                
                <input 
                    type="text"
                    placeholder='Username'
                    className='signupInput'
                    name='username'
                    id="login_username"
                    onChange = {handleChange}
                />
                <div className="input-container">
                <input 
                    type={showPassword0 ? "text" : "password"}
                    placeholder='Password'
                    className='signupInput'
                    name='password'
                    id="login_password"
                    onChange = {handleChange}
                />
                {showPassword0 ? (
                    <svg className="eye-icon" fill="#000000" stroke="#000000" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" onClick={togglePasswordVisibility0}><path d="M802.219871 221.61333c-10.022261-10.022261-26.278503-10.022261-36.275181 0L221.830271 765.726725c-10.022261 10.022261-10.022261 26.252921 0 36.275182 10.022261 10.022261 26.252921 10.022261 36.275182 0l544.113395-544.113395c9.998725-10.021238 9.998725-26.27748 0.001023-36.275182z" fill="" /><path d="M802.363134 221.99707c-10.022261-10.022261-26.278503-10.022261-36.275182 0L221.973534 766.111488c-10.022261 10.022261-10.022261 26.252921 0 36.275182 10.022261 10.022261 26.252921 10.022261 36.275181 0l544.113395-544.113395c10.024308-9.998725 10.024308-26.253944 0.001024-36.276205zM551.908942 370.744859c-12.660344-3.548826-25.942859-5.610788-39.751353-5.610788-80.990592 0-146.661268 65.670675-146.661268 146.661268 0 13.787004 2.037403 27.093055 5.609765 39.751352l180.802856-180.801832zM473.076502 653.014664c12.467963 3.452635 25.53456 5.442966 39.105647 5.442966 80.990592 0 146.661268-65.670675 146.661267-146.661268 0-13.571087-1.990331-26.637684-5.442966-39.105646L473.076502 653.014664z" fill="" /><path d="M233.914494 688.714747l34.500768-34.500768c-54.498218-36.084846-101.370759-84.252893-136.25629-142.0349C212.671681 378.75223 356.984461 296.394501 512.01228 296.394501c34.742269 0 68.882833 4.339842 101.969392 12.275581l39.032992-39.032992c-45.194318-13.690814-92.594885-21.171182-141.003408-21.171182-176.824241 0-341.011674 96.55201-428.501284 251.965615l-6.616698 11.772115 6.616698 11.773138c37.644365 66.819848 89.5045 122.68418 150.404522 164.737971zM940.490028 500.4305C902.918317 433.657724 851.105255 377.841487 790.30347 335.787696l-34.477232 34.477232c54.402027 36.059264 101.202936 84.180238 136.040372 141.915174-80.488149 133.451408-224.799906 215.784578-379.852284 215.784578-34.646078 0-68.691475-4.339842-101.682867-12.202926l-39.056527 39.056527c45.122687 13.641695 92.428086 21.098527 140.739394 21.098527 176.847777 0 341.036233-96.55201 428.476725-251.989151l6.615675-11.747555-6.616698-11.749602z" fill="" /></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" stroke="#000000" className="eye-icon" viewBox="0 0 128 128" onClick={togglePasswordVisibility0}>
                        <path d="M64 104C22.127 104 1.367 67.496.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24s62.633 36.504 63.496 38.057a4 4 0 0 1 0 3.887C126.633 67.496 105.873 104 64 104zM8.707 63.994C13.465 71.205 32.146 96 64 96c31.955 0 50.553-24.775 55.293-31.994C114.535 56.795 95.854 32 64 32 32.045 32 13.447 56.775 8.707 63.994zM64 88c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm0-40c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16z" data-original="#000000"></path>
                    </svg>
                    )}
                </div>
                <div id="auth_login_validation" className='validationError General-hidden'></div>
                <div className="loginSignup" onClick={()=>setRightComponent("signUp")}>
                    Don't have an account?  Sign up.
                </div>
                <div className="loginSignup" onClick={()=>setRightComponent("forgot")}>
                    Forgot your password?
                </div>
                <button className="button signupButton" type="submit" disabled={loading}>
                    {loading ? "Loading..." : "Log In"}
                </button>
                
                    
            </form>
        </div>
    )
}

function SignUp({ setRightComponent, handleChange, handleSubmitSignup, loading, showPassword, showPassword2, togglePasswordVisibility, togglePasswordVisibility2, data }) {

    return (
        <div className="auth-right">
            <form action="" className="input-form" onSubmit={handleSubmitSignup}>
                <h3>Sign Up</h3>
                
                <label 
                    name="userType"
                    className='signupDropdownLabel'
                >
                    <span>
                        User Type:
                    </span>
                    <select 
                        name="userType" 
                        className='signupDropdown'
                        onChange = {handleChange}
                    >
                        <option value="0">General User</option>
                        <option value="1">Author</option>
                        {/* <option value="2">Group</option> */}
                    </select>
                </label>
                <input 
                    type="email"
                    placeholder='Email'
                    className='signupInput'
                    name='email'
                    id="auth_displayemail"
                    onChange = {handleChange}
                />
                <input 
                    type="text"
                    placeholder='Name'
                    className='signupInput'
                    name='displayname'
                    id="auth_displayname"
                    onChange = {handleChange}
                />
                <input 
                    type="text"
                    placeholder='Username'
                    className='signupInput'
                    name='username'
                    id="auth_username"
                    onChange = {handleChange}
                />
                <div className="input-container">
                <input 
                    type={showPassword ? "text" : "password"}
                    placeholder='Password'
                    className='signupInput'
                    name='password'
                    id="auth_password"
                    onChange = {handleChange}
                />
                {showPassword ? (
                    <svg className="eye-icon" fill="#000000" stroke="#000000" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" onClick={togglePasswordVisibility}><path d="M802.219871 221.61333c-10.022261-10.022261-26.278503-10.022261-36.275181 0L221.830271 765.726725c-10.022261 10.022261-10.022261 26.252921 0 36.275182 10.022261 10.022261 26.252921 10.022261 36.275182 0l544.113395-544.113395c9.998725-10.021238 9.998725-26.27748 0.001023-36.275182z" fill="" /><path d="M802.363134 221.99707c-10.022261-10.022261-26.278503-10.022261-36.275182 0L221.973534 766.111488c-10.022261 10.022261-10.022261 26.252921 0 36.275182 10.022261 10.022261 26.252921 10.022261 36.275181 0l544.113395-544.113395c10.024308-9.998725 10.024308-26.253944 0.001024-36.276205zM551.908942 370.744859c-12.660344-3.548826-25.942859-5.610788-39.751353-5.610788-80.990592 0-146.661268 65.670675-146.661268 146.661268 0 13.787004 2.037403 27.093055 5.609765 39.751352l180.802856-180.801832zM473.076502 653.014664c12.467963 3.452635 25.53456 5.442966 39.105647 5.442966 80.990592 0 146.661268-65.670675 146.661267-146.661268 0-13.571087-1.990331-26.637684-5.442966-39.105646L473.076502 653.014664z" fill="" /><path d="M233.914494 688.714747l34.500768-34.500768c-54.498218-36.084846-101.370759-84.252893-136.25629-142.0349C212.671681 378.75223 356.984461 296.394501 512.01228 296.394501c34.742269 0 68.882833 4.339842 101.969392 12.275581l39.032992-39.032992c-45.194318-13.690814-92.594885-21.171182-141.003408-21.171182-176.824241 0-341.011674 96.55201-428.501284 251.965615l-6.616698 11.772115 6.616698 11.773138c37.644365 66.819848 89.5045 122.68418 150.404522 164.737971zM940.490028 500.4305C902.918317 433.657724 851.105255 377.841487 790.30347 335.787696l-34.477232 34.477232c54.402027 36.059264 101.202936 84.180238 136.040372 141.915174-80.488149 133.451408-224.799906 215.784578-379.852284 215.784578-34.646078 0-68.691475-4.339842-101.682867-12.202926l-39.056527 39.056527c45.122687 13.641695 92.428086 21.098527 140.739394 21.098527 176.847777 0 341.036233-96.55201 428.476725-251.989151l6.615675-11.747555-6.616698-11.749602z" fill="" /></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" stroke="#000000" className="eye-icon" viewBox="0 0 128 128" onClick={togglePasswordVisibility}>
                        <path d="M64 104C22.127 104 1.367 67.496.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24s62.633 36.504 63.496 38.057a4 4 0 0 1 0 3.887C126.633 67.496 105.873 104 64 104zM8.707 63.994C13.465 71.205 32.146 96 64 96c31.955 0 50.553-24.775 55.293-31.994C114.535 56.795 95.854 32 64 32 32.045 32 13.447 56.775 8.707 63.994zM64 88c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm0-40c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16z" data-original="#000000"></path>
                    </svg>
                    )}
                </div>
                <div className="input-container">
                    <input 
                        type={showPassword2 ? "text" : "password"}
                        placeholder='Confirm Password'
                        className='signupInput'
                        name='confirmPassword'
                        id="auth_confirm"
                        onChange = {handleChange}
                    />
                    {showPassword2 ? (
                        <svg className="eye-icon" fill="#000000" stroke="#000000" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" onClick={togglePasswordVisibility2}><path d="M802.219871 221.61333c-10.022261-10.022261-26.278503-10.022261-36.275181 0L221.830271 765.726725c-10.022261 10.022261-10.022261 26.252921 0 36.275182 10.022261 10.022261 26.252921 10.022261 36.275182 0l544.113395-544.113395c9.998725-10.021238 9.998725-26.27748 0.001023-36.275182z" fill="" /><path d="M802.363134 221.99707c-10.022261-10.022261-26.278503-10.022261-36.275182 0L221.973534 766.111488c-10.022261 10.022261-10.022261 26.252921 0 36.275182 10.022261 10.022261 26.252921 10.022261 36.275181 0l544.113395-544.113395c10.024308-9.998725 10.024308-26.253944 0.001024-36.276205zM551.908942 370.744859c-12.660344-3.548826-25.942859-5.610788-39.751353-5.610788-80.990592 0-146.661268 65.670675-146.661268 146.661268 0 13.787004 2.037403 27.093055 5.609765 39.751352l180.802856-180.801832zM473.076502 653.014664c12.467963 3.452635 25.53456 5.442966 39.105647 5.442966 80.990592 0 146.661268-65.670675 146.661267-146.661268 0-13.571087-1.990331-26.637684-5.442966-39.105646L473.076502 653.014664z" fill="" /><path d="M233.914494 688.714747l34.500768-34.500768c-54.498218-36.084846-101.370759-84.252893-136.25629-142.0349C212.671681 378.75223 356.984461 296.394501 512.01228 296.394501c34.742269 0 68.882833 4.339842 101.969392 12.275581l39.032992-39.032992c-45.194318-13.690814-92.594885-21.171182-141.003408-21.171182-176.824241 0-341.011674 96.55201-428.501284 251.965615l-6.616698 11.772115 6.616698 11.773138c37.644365 66.819848 89.5045 122.68418 150.404522 164.737971zM940.490028 500.4305C902.918317 433.657724 851.105255 377.841487 790.30347 335.787696l-34.477232 34.477232c54.402027 36.059264 101.202936 84.180238 136.040372 141.915174-80.488149 133.451408-224.799906 215.784578-379.852284 215.784578-34.646078 0-68.691475-4.339842-101.682867-12.202926l-39.056527 39.056527c45.122687 13.641695 92.428086 21.098527 140.739394 21.098527 176.847777 0 341.036233-96.55201 428.476725-251.989151l6.615675-11.747555-6.616698-11.749602z" fill="" /></svg>
                        ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" stroke="#000000" className="eye-icon" viewBox="0 0 128 128" onClick={togglePasswordVisibility2}>
                            <path d="M64 104C22.127 104 1.367 67.496.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24s62.633 36.504 63.496 38.057a4 4 0 0 1 0 3.887C126.633 67.496 105.873 104 64 104zM8.707 63.994C13.465 71.205 32.146 96 64 96c31.955 0 50.553-24.775 55.293-31.994C114.535 56.795 95.854 32 64 32 32.045 32 13.447 56.775 8.707 63.994zM64 88c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm0-40c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16z" data-original="#000000"></path>
                        </svg>
                    )}
                </div>
                {data && data.userType === "1" && 
                    <input 
                        type="text"
                        placeholder='Author Signup Key'
                        className='signupInput'
                        name='signupKey'
                        id="auth_signupKey"
                        onChange = {handleChange}
                    />
                }
                <div id="auth_signup_validation" className='validationError General-hidden'></div>
                <div className="loginSignup" onClick={()=>setRightComponent("logIn")}>
                    Already have an account?  Log in.
                </div>
                <button className="button signupButton" type="submit" disabled={loading}>
                    {loading ? "Loading..." : "Sign Up"} 
                </button>
                    
            </form>
        </div>
    )
}

function Forgot({ setRightComponent, handleChange, loading, handleSubmitForgot }) {
    return (
        <div className="auth-right">
            <form action="" className="input-form" onSubmit={handleSubmitForgot}>
                <h3>Forgot Password</h3>
                {/* <span className='auth-instruction'>If you forgot your password, please contact North Star admin to have it reset, then proceed with this Update form.</span> */}
                <input 
                    type="text"
                    placeholder='Email'
                    className='signupInput'
                    name='email'
                    id="forgot_"
                    onChange = {handleChange}
                />
                
                <div id="auth_forgot_validation" className='General-validationError General-hidden'></div>
                <div className="loginSignup" onClick={()=>setRightComponent("logIn")}>
                    Back to Login.
                </div>
                <button className="button signupButton" type="submit" disabled={loading}>
                    {loading ? "Loading..." : "Get Link"}
                </button>
                
                    
            </form>
        </div>
    )
}


export default Auth